import React from 'react';
import TransformSection from './common/transform-section';
import { registerInspector } from './inspector-registry';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import NumberField from './shared/number-field';
import { useFabricProp } from './shared/use-fabric-prop';
import type { ObjectInspectorProps } from './types';

const ImageInspector: React.FC<ObjectInspectorProps> = ({ object, editor }) => {
  const [scaleX, setScaleX] = useFabricProp<number>(object, 'scaleX', editor);
  const [scaleY, setScaleY] = useFabricProp<number>(object, 'scaleY', editor);
  const [opacity, setOpacity] = useFabricProp<number>(object, 'opacity', editor);

  return (
    <>
      <TransformSection object={object} editor={editor} />
      <InspectorSection title="Appearance">
        <InspectorRow label="Scale X">
          <NumberField value={scaleX} onChange={setScaleX} step={0.05} min={0.01} />
        </InspectorRow>
        <InspectorRow label="Scale Y">
          <NumberField value={scaleY} onChange={setScaleY} step={0.05} min={0.01} />
        </InspectorRow>
        <InspectorRow label="Opacity">
          <NumberField value={opacity} onChange={setOpacity} step={0.05} min={0} max={1} />
        </InspectorRow>
      </InspectorSection>
    </>
  );
};

export default ImageInspector;

registerInspector('image', ImageInspector);
